import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useHasPermission } from '~/modules/common/permissions';

export const RESOURCE_SCHEDULE_DURATION_BY_DAY_FOR_USERS_QUERY = gql`
  query GetResourceUsersWithScheduleDurationByDay(
    $userIds: [String!]
    $dateRange: DateRangeInput!
  ) {
    getScheduleDurationByDayForUsers(dateRange: $dateRange, userIds: $userIds) {
      userId
      scheduleDurationByDay {
        date
        hours
      }
    }
  }
`;

export const useGetScheduleDurationByDayForUsers = ({
  dateRange,
  userIds = [],
  skip = false
}) => {
  const variables = {
    dateRange,
    userIds
  };
  const canViewAvailability = useHasPermission({
    actionUri: 'urn:replicon:user-action:view-availability'
  });

  const { loading: loadingRows, error, data = {} } = useQuery(
    RESOURCE_SCHEDULE_DURATION_BY_DAY_FOR_USERS_QUERY,
    {
      fetchPolicy: 'cache-first',
      variables,
      skip: !canViewAvailability || !userIds.length || skip
    }
  );

  const getScheduleDurationByDayForUsers =
    (data && data.getScheduleDurationByDayForUsers) || [];

  return {
    loadingRows: loadingRows || false,
    scheduleDurations: getScheduleDurationByDayForUsers || [],
    error
  };
};

export default useGetScheduleDurationByDayForUsers;
